import React, { Component } from "react";
import WithCard from "../../../../common/withCard";
import DropDown from "../../common/dropDown/dropDown";
import AreaChartHolder from "../AssetClass/section1/areaChartHolder";
import MultiLineHolder from "./section1/multilineHolder";
import SkittleHolder from "./section1/skittleHolder";

import "./assetClass.css";

// import TableHolder from "./section1/tableHolder";

class AssetClassHolder extends Component {
  state = {
    selected: "asset_class_stock_place",
    options: [
      {
        name: "asset_class_stock_place",
        text: "Area Chart",
        icon: "fa-area-chart fs_icon_option",
      },
      {
        name: "multi1",
        text: "Line Chart",
        icon: "fa-line-chart fs_icon_option",
      },
      {
        name: "skittleChart",
        text: "Skittle Chart",
        icon: "fa-th fs_icon_option",
      },
    ],
    style: { left: "-150px", right: "20px" },
    res: [],
  };

  onclickHandler = (e) => {
    e.preventDefault();
    this.props.assetHamburgerHandler(e.target.name);
    if (e.target.name) {
      this.setState({
        selected: e.target.name,
      });
    }
  };

  componentDidMount() {
    this.setState({
      res: this.props.res,
    });
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.res) !== JSON.stringify(nextProps.res)) {
      this.setState({
        res: nextProps.res,
      });
    }
  }
  render() {
    const { selected, options, style } = this.state;
    const { res } = this.state;
    return (
      <WithCard>
        <div className="asset_classHead">
          <h4 className="text-uppercase bold">Asset Class Exposure</h4>
          {options ? (
            <DropDown
              onclickHandler={this.onclickHandler}
              data={options}
              style={style}
            />
          ) : null}
        </div>
        <div>
          {selected === "asset_class_stock_place" &&
          Object.keys(res).length > 0 ? (
            <AreaChartHolder res={res} />
          ) : null}
          {selected === "multi1" && Object.keys(res).length > 0 ? (
            <MultiLineHolder res={res} />
          ) : null}
          {selected === "skittleChart" && Object.keys(res).length > 0 ? (
            <SkittleHolder res={res} />
          ) : null}
        </div>
      </WithCard>
    );
  }
}

export default AssetClassHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/AssetClassHolder.jsx